<script>
import Config from "/config"
import { mapGetters } from "vuex"
export default {
  props: {
    trigger: { default: false, type: Boolean },
  },
  data() {
    return {
      username: "",
      password: "",
      authService: `${Config.auth.authService}login`,
      sso: `${Config.auth.cas}login`,
      ssoUrl: `${Config.auth.cas}login?service=${Config.auth.serviceName}`,
      userRegUrl: Config.profile.userRegUrl,
      newAccountUrl: `${Config.profile.userRegUrl}/#/new`,
      accountLookupUrl: `${Config.profile.userRegUrl}/#/forgot`,
    }
  },
  computed: {
    serviceURL() {
      return `${origin}/`
    },
    ...mapGetters("AuthService", [
      "showWarningMsg",
      "getWarningMsg",
      "getAccountExpired",
    ]),
  },
  methods: {
    onLogin() {
      // Auth Service Login
      this.$store.dispatch("AuthService/basicLogin", {
        username: this.username,
        password: this.password,

      // GraphQL Login
      }).then(authResp => {
        //console.log("authResp:", authResp)
        if (authResp.status == 200) {
          return this.$store.dispatch("GraphQL/loginWithTicket", authResp.data.ticket)
        }

      // Login Completed
      }).then(graphResp => {
        //console.log("graphResp:", graphResp)
        if (graphResp.status == 200) {
          this.$store.dispatch("SessionManager/newSession")
          this.$emit("hide")
        }
      
      // Something Went Wrong
      }).catch(err => {
        console.log("Login Error:", err)
        this.$store.dispatch("SessionManager/logout")
      })
    },
    closeLogin() {
      this.$emit("hide")
    },
    resetFields() {
      this.username = ""
      this.password = ""
    },
  },
}
</script>

<template>
  <div>
    <!-- Login Modal -->
    <b-modal
      id="loginModal"
      v-model="trigger"
      title="Login"
      hide-header
      hide-footer
      @show="resetFields"
      @hidden="closeLogin"
    >
      <h3>Login</h3>
      <b-row v-if="showWarningMsg" class="text-danger">
        <b-col>
          <b-card
            v-if="getAccountExpired"
            class="softBlackColor primaryBackgroundLight"
          >
            Please take a few moments to
            <a
              id="userRegUrl"
              :href="userRegUrl"
              target="_blank"
            >update and confirm your ARM profile using this link</a>.
            This information is required by the U.S. Department of Energy Office of Science for documenting
            the value and usage of Atmospheric Radiation Measurement user facility to the research community.
            We apologize for any inconvenience; once your profile is updated and complete, you may proceed to request data.
          </b-card>
          <template v-else>
            {{getWarningMsg}}
          </template>
        </b-col>
      </b-row>
      <b-form @submit.prevent="onLogin">
        <b-row>
          <b-col>
            <b-form-input
              id="username"
              v-model="username"
              type="text"
              required
              placeholder="Email or ARM User ID"
              autocomplete="username"
              @keyup.enter="onLogin"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input
              id="password"
              v-model="password"
              type="password"
              required
              placeholder="Enter Password"
              autocomplete="current-password"
              @keyup.enter="onLogin"
            />
          </b-col>
        </b-row> 
        <b-row>
          <b-col>
            <b-button type="button" class="loginButton" squared @click="onLogin">Log In</b-button>
            <!--<br /><br />
            <a :href="ssoUrl">
              <u>Log In with Single-Sign-On</u>
            </a>-->
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <a :href="newAccountUrl" target="_blank">
              <u>Set up an Account</u>
            </a>
            &nbsp;|&nbsp;
            <a :href="accountLookupUrl" target="_blank">
              <u>Lookup Your ID</u>
            </a>
          </b-col>
        </b-row>
        <!--        <b-row>-->
        <!--          <b-col>-->
        <!--            <b-button type="submit" class="loginButton">Log In</b-button>-->
        <!--          </b-col>-->
        <!--        </b-row>-->
        <b-row>
          <b-col>
            <a class="closeLink"><span @click="closeLogin">Close</span></a>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<style>
#loginModal {
  text-align: center;
}
#loginModal .modal-body {
  background-color: #ebebeb;
  padding: 40px;
  padding-bottom: 20px;
}
#loginModal h3 {
  color: #414141;
  font-family: "Proxima Nova";
  font-size: 42px;
  font-weight: bold;
  line-height: 50px;
}
#loginModal .row {
  padding-top: 5px;
  padding-bottom: 5px;
}
#loginModal .loginButton {
  width: 220px;
  color: #e1e1e1;
}
#loginModal a {
  color: #414141;
}
#loginModal a.closeLink,
#loginModal a.closeLink:link,
#loginModal a.closeLink:visited {
  text-decoration: underline;
}
#loginModal a.closeLink:hover,
#loginModal a.closeLink:active {
  cursor: pointer;
}

#loginModal .card-body {
  text-align: left !important;
}

#loginModal #userRegUrl {
  text-decoration: underline;
}
</style>
